<template>
  <div>
    <!-- <shop-head currentPageName="LOGIN"></shop-head> -->
    <!-- 面包屑 -->
    <!-- <breadcrumb pageName="修改密码"></breadcrumb> -->
    <div style="width: 100%;background-color: #fff;position: relative;">
      <div style="width: 339px;height: 239px;position: absolute;cursor: pointer;" @click="() => {
        this.$router.push({
          path: '/home'
        })
      }"></div>
      <img class="head-bg" v-if="la == 'zh'" src="../../assets/images/head-bg.png" alt="" style="">
      <img class="head-bg" v-else src="../../assets/images/head-bg-en.png" alt="" style="">
    </div>
    <div class="login-box">
      <img class="login-bg" src="../../assets/images/login-bg.png" alt="">
      <el-row type="flex" justify="center">
        <el-col :md="12">
          <div class="login-form">
            <div class="login-title">{{ $t('找回密码') }}</div>
            <el-form ref="form" :model="form" class="form" :rules="rules" label-position="top">
              <el-form-item label="" prop="phone">
                <el-input v-model="form.phone" autocomplete="off" prefix-icon="el-icon-phone-outline" :placeholder="$t('手机号')"></el-input>
              </el-form-item>
              <el-form-item label="" prop="phoneCode">
                <el-input v-model="form.phoneCode" autocomplete="off" prefix-icon="el-icon-chat-round
                " :placeholder="$t('验证码')">
                  <template slot="append"><el-button :disabled="sendBtn != $t('发送验证码')" @click="sendCode">{{ sendBtn
                      }}</el-button></template>
                </el-input>
              </el-form-item>
              <el-form-item label="" prop="password">
                <el-input v-model="form.password" autocomplete="off" type="password" prefix-icon="el-icon-user"
                  :placeholder="$t('新密码')"></el-input>
              </el-form-item>
              <el-button type="primary" @click="gotoLogin" el-icon-office-building>{{ $t('修改密码') }}</el-button>
              <el-button type="text" @click="() => {
                this.$router.push({
                  path: '/login'
                })
              }">{{ $t('登录') }}</el-button>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
import shopHead from '../../components/shop/head'
import commonFooter from '../../components/common/footer'
import breadcrumb from '../../components/common/breadcrumb'
import { phonecode, setPassword } from '../../apis/user'
export default {
  components: {
    shopHead,
    commonFooter,
    breadcrumb
  },
  data() {
    return {
      isRemember: false,
      sendBtn: '',
      la: '',
      form: {
        "phone": "",
        "phoneCode": "",
        "password": ""
      },
      rules: {
        phone: [{ required: true, message: ' ', trigger: 'blur' }],
        password: [{ required: true, message: ' ', trigger: 'blur' }],
        phoneCode: [{ required: true, message: ' ', trigger: 'blur' }],
      }
    }
  },
  created() {
    this.sendBtn = this.$cookie.get('language') == 'zh' ? '发送验证码' : 'Send Code'
    this.la = this.$cookie.get('language') || 'zh';
  },
  methods: {
    /** 跳转到登录页 */
    gotoLogin() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            await setPassword(this.form)
            this.$router.push({
              path: '/login'
            })
          } catch (e) {
            this.$message({
              message: e.message,
              type: 'error'
            });
          }
        }
      });
    },
    sendCode() {
      phonecode({ phone: this.form.phone }).then((res) => {
        if (res.code != 200) {
          this.$message({
            message: res.msg,
            type: 'warning'
          });
          return;
        }
        let num = 60
        let timeer = setInterval(() => {
          this.sendBtn = `${this.$i18n.t('再次发送')}(${num--}${this.$i18n.t('秒')})`
          if (num < 0) {
            clearInterval(timeer)
            this.sendBtn = this.$i18n.t('发送验证码')
          }
        }, 1000);
      }).catch((e) => {
        this.$message({
          message: e.message,
          type: 'error'
        });
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login-box {
  // padding: 60px 15px;
  height: 477px;

  .login-bg {
    width: 100%;
    position: absolute;
    height: 500px;
    object-fit: fill;
    left: 0px;
    margin-bottom: 20px;
  }

  .login-form {
    position: absolute;
    left: 63%;
    width: 460px;
    margin-top: 63px;
    background-color: #ffffff;
    padding: 30px;
    box-shadow: 1px 1px 5px 5px rgb(0, 0, 0, 0.1);

    .form {
      height: 310px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;

      .el-checkbox__label {
        white-space: wrap;
      }
    }

    .login-title {
      font-size: 20px;
      line-height: 23px;
      text-transform: capitalize;
      font-weight: 700;
      margin-bottom: 0;
      padding-bottom: 20px;
    }

    ::v-deep .el-form-item {
      margin-bottom: 15px;
    }

    ::v-deep .el-form-item__label {
      font-weight: bold;
      line-height: 24px;
      margin-bottom: 12px;
      padding-bottom: 0;
    }

    ::v-deep .el-input__inner {
      border-radius: 0;

      &:focus {
        border-color: #fed100;
      }
    }

    ::v-deep .el-checkbox__input {
      &.is-checked {
        &+.el-checkbox__label {
          color: #fed100;
        }

        .el-checkbox__inner {
          border-color: #fed100;
          background-color: #fed100;
        }
      }

      &.is-focus {
        .el-checkbox__inner {
          border-color: #fed100;
        }
      }
    }

    ::v-deep .el-checkbox__inner {
      &:hover {
        border-color: #fed100;
      }
    }

    ::v-deep .el-checkbox__label {
      font-weight: 400;
      color: #888888;
    }
  }

  .login-btn {
    width: 140px;
    height: 40px;
    line-height: 40px;
    font-weight: bold;
    text-align: center;
    color: #ffffff;
    display: block;
    margin-top: 30px;
    border-radius: 0;
    border: 0;
    text-transform: uppercase;
    background-color: #333333;
    cursor: pointer;

    &:hover {
      background-color: #fed100;
    }
  }
}
</style>